<div class="settings-page">

  <div class="settings-page__header">
    <span class="settings-page__icon" aria-hidden="true">⚙️</span>
    <div>
      <h1 class="settings-page__title">{{ 'pages.settings.title' | translate }}</h1>
      <p class="settings-page__subtitle">{{ 'pages.settings.subtitle' | translate }}</p>
    </div>
  </div>

  <section class="settings-section">
    <div class="settings-section__header">
      <span class="settings-section__icon" aria-hidden="true">🔤</span>
      <div>
        <h2 class="settings-section__title">{{ 'settings.typography.title' | translate }}</h2>
        <p class="settings-section__desc">{{ 'settings.typography.desc' | translate }}</p>
      </div>
    </div>

    <!-- Arabic Font -->
    <div class="font-setting">
      <label class="font-setting__label">
        <span class="font-setting__lang-badge">🇸🇦</span>
        {{ 'settings.typography.arabic_font' | translate }}
      </label>
      <div class="font-picker">
        @for (font of fontService.arabicFonts; track font.id) {
          <button
            type="button"
            class="font-card"
            [class.font-card--active]="fontService.selectedArabicFontId() === font.id"
            (click)="selectArabicFont(font)"
          >
            @if (fontService.selectedArabicFontId() === font.id) {
              <span class="font-card__check" aria-hidden="true">✓</span>
            }
            <span class="font-card__preview" [style.font-family]="font.cssFamily" dir="rtl">
              {{ font.previewAr }}
            </span>
            <span class="font-card__name">{{ font.name }}</span>
            <span class="font-card__name-local" [style.font-family]="font.cssFamily" dir="rtl">
              {{ font.nameLocal }}
            </span>
          </button>
        }
      </div>
    </div>

    <!-- Urdu Font -->
    <div class="font-setting">
      <label class="font-setting__label">
        <span class="font-setting__lang-badge">🇮🇳</span>
        {{ 'settings.typography.urdu_font' | translate }}
      </label>
      <div class="font-picker">
        @for (font of fontService.urduFonts; track font.id) {
          <button
            type="button"
            class="font-card"
            [class.font-card--active]="fontService.selectedUrduFontId() === font.id"
            (click)="selectUrduFont(font)"
          >
            @if (fontService.selectedUrduFontId() === font.id) {
              <span class="font-card__check" aria-hidden="true">✓</span>
            }
            <span class="font-card__preview" [style.font-family]="font.cssFamily" dir="rtl">
              {{ font.previewUr }}
            </span>
            <span class="font-card__name">{{ font.name }}</span>
            <span class="font-card__name-local" [style.font-family]="font.cssFamily" dir="rtl">
              {{ font.nameLocal }}
            </span>
          </button>
        }
      </div>
    </div>

  </section>

</div>
